function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.15311e-07 7.02504L9.99194 11.3524V24L1.20716 20.0706C0.847714 19.9097 0.54233 19.6471 0.328054 19.3148C0.113778 18.9825 -0.0001808 18.5946 2.15311e-07 18.1983V7.02504ZM21.6774 6.76362V18.1983C21.6775 18.5945 21.5634 18.9822 21.3492 19.3144C21.1349 19.6466 20.8296 19.909 20.4703 20.0699L12.0242 23.8485V11.2452L21.6774 6.76294V6.76362ZM11.6638 0.176357L20.4703 4.1167C20.7765 4.25321 21.0373 4.46139 21.2371 4.7153L10.9247 9.52726L0.296032 4.92416C0.506032 4.57469 0.821032 4.28939 1.20716 4.1167L10.0136 0.176357C10.2734 0.0600797 10.5545 0 10.8387 0C11.123 0 11.404 0.0600797 11.6638 0.176357Z",
  fill: "black"
});

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.64621a9f.svg";
export { ForwardRef as ReactComponent };